import React, { useState } from 'react';
import AboutHeader from './AboutHeader';
import NavMobile from './AboutNavMobile';
import AboutHero from './AboutHero';
import LuoChef from './LuoChef';
import LuoAwards from './LuoAwards';
import LuoFooter from './LuoFooter';

const Luo = () => {
  const [navMobile, setNavMobile] = useState(true);
  return (
    <div>
      <AboutHeader setNavMobile={setNavMobile}/>
      <AboutHero />
       {/* mobile nav */}
       <div className={`${navMobile ? 'right-0' : '-right-full'} fixed top-0 bottom-0 w-[340px] transition-all`}>
        <NavMobile setNavMobile={setNavMobile}/>
      </div>
      <LuoChef />
      <LuoAwards />
      <LuoFooter />
    </div>
  )
}

export default Luo